import { useEffect, useState } from 'react';
import Head from 'next/head';
import { Box } from 'theme-ui';
import { useCartAddItem, useCartAddItems } from '@backpackjs/storefront';

import { useSidebar } from '@hooks';

import { themed } from './Personalize.theme';

export const PersonalizeModal = themed(({ theme, variantId }) => {
  const { cartAddItem } = useCartAddItem();
  const { cartAddItems } = useCartAddItems();
  const [, { openCartSidebar }] = useSidebar();

  const [atcInjected, setAtcInjected] = useState(false);

  useEffect(() => {
    window.__packCommerce = {};

    const remoteMultipleAtc = async (items) => {
      try {
        if (
          !Array.isArray(items) ||
          !items?.every((item) => typeof item === 'object')
        ) {
          throw new Error(
            `An array of objects is required to be passed in. Received: \`${items}\``
          );
        }
        const itemsToAdd = items.map(
          ({ merchandiseId, quantity, attributes }) => {
            if (!merchandiseId) {
              throw new Error(
                `\`merchandiseId\` is a required property of each item`
              );
            }
            if (!quantity) {
              throw new Error(
                `\`quantity\` is a required property for each item. Missing for item with \`merchandiseId\` \`${merchandiseId}\``
              );
            }
            if (attributes) {
              attributes.forEach((attr) => {
                const hasKeyValue =
                  attr?.key !== undefined && attr?.value !== undefined;
                if (!hasKeyValue) {
                  throw new Error(
                    '`attributes` must be array of objects with `key` and `value`, e.g. `[{ key: "color", value: "red" }]`'
                  );
                }
              });
            }
            return {
              merchandiseId,
              quantity,
              ...(attributes ? { attributes } : null),
            };
          }
        );

        const cart = await cartAddItems(itemsToAdd);

        if (cart) {
          openCartSidebar();
        }

        return true;
      } catch (error) {
        console.error(
          'Error with __packCommerce.remoteMultipleAtc:',
          error.message
        );
        return false;
      }
    };

    const remoteAtc = async (
      { merchandiseId, quantity, attributes } = {
        merchandiseId: null,
        quantity: 1,
        attributes: null,
      }
    ) => {
      try {
        const hasAttributes = attributes?.every((attr) => {
          const hasKeyValue =
            attr?.key !== undefined && attr?.value !== undefined;
          if (!hasKeyValue) {
            throw new Error(
              '`attributes` must be array of objects with `key` and `value`, e.g. `[{ key: "color", value: "red" }]`'
            );
          }
          return hasKeyValue;
        });

        const cart = await cartAddItem({
          merchandiseId,
          quantity,
          ...(hasAttributes ? { attributes } : null),
        });

        if (cart) {
          openCartSidebar();
        }

        return true;
      } catch (error) {
        console.error('Error with __packCommerce.remoteAtc:', error.message);
        return false;
      }
    };

    window.__packCommerce.remoteMultipleAtc = remoteMultipleAtc;
    window.__packCommerce.remoteAtc = remoteAtc;
    setAtcInjected(true);
  }, []);

  return (
    <Box data-comp={PersonalizeModal.displayName} sx={theme.modal}>
      {atcInjected && (
        <>
          <Head>
            <script
              src={`https://silhouette.jtbcustom.com/js/loader/${variantId}.js?store_key=61GbV5ck`}
              type="text/javascript"
            />
          </Head>

          <div id="jtbconfigurator" />
        </>
      )}
    </Box>
  );
});

PersonalizeModal.displayName = 'PersonalizeModal';
